
import React from 'react';
import Layout from '@/components/Layout';
import { useParams } from 'react-router-dom';

const LessonDetailsPage: React.FC = () => {
  const { courseId, lessonId } = useParams();

  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Lesson Details</h1>
        <p className="mt-4">Viewing lesson {lessonId} from course {courseId}</p>
      </div>
    </Layout>
  );
};

export default LessonDetailsPage;
